import React from "react";
import * as Assets from "../../../utils/svg_assets";
import "./style.scss";

const NoData = (p) => {
  const title =
    p.activeNav === 0
      ? "Events / Appointments / Greetings"
      : p.activeNav === 1
      ? "Events"
      : p.activeNav === 2
      ? "Appointments"
      : "Greetings";
  return (
    <div className="calendar-no-data">
      <div className="title">No {title}</div>
      <img src={Assets.iconCalendarNoData} alt="logo_image" />
      <div className="desc">There is no {title} in this time period.</div>
    </div>
  );
};

export default NoData;
